import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useData } from '../../contexts/DataContext';
import { useLang } from '../../contexts/LangContext';
import AlunaTabBar from '../../components/AlunaTabBar';

const DIAS_SEMANA = {
  pt: ['Dom','Seg','Ter','Qua','Qui','Sex','Sáb'],
  en: ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'],
};
const MESES = {
  pt: ['Janeiro','Fevereiro','Março','Abril','Maio','Junho','Julho','Agosto','Setembro','Outubro','Novembro','Dezembro'],
  en: ['January','February','March','April','May','June','July','August','September','October','November','December'],
};
const TIPOS_CONSULTA = {
  avaliacao: { pt: 'Avaliação física', en: 'Physical assessment' },
  revisao_treino: { pt: 'Consulta Personal', en: 'Training consultation' },
  revisao_nutricao: { pt: 'Consulta Nutrição', en: 'Nutrition consultation' },
};

const s = {
  page: { minHeight: '100vh', background: '#f3eee7', padding: '26px 14px 40px', fontFamily: "-apple-system, BlinkMacSystemFont, 'SF Pro Display', 'SF Pro Text', 'Inter', sans-serif" },
  nav: { width: 'min(100%, 430px)', margin: '0 auto -1px', background: '#fffaf4', borderRadius: '44px 44px 0 0', padding: '28px 22px 0', display: 'flex', alignItems: 'center', justifyContent: 'space-between', position: 'relative', zIndex: 50, boxShadow: '0 -18px 80px rgba(66,44,38,.08), inset 0 1px 0 rgba(255,255,255,.95)' },
  navLogo: { fontFamily: "'Inter', sans-serif", fontSize: '16px', fontWeight: 900, color: 'var(--text)' },
  navLogoSpan: { color: 'var(--accent)' },
  backBtn: { height: '42px', padding: '0 14px', background: 'rgba(255,255,255,.54)', border: '1px solid rgba(216,202,182,.86)', color: '#7f7165', borderRadius: '999px', fontSize: '13px', cursor: 'pointer' },
  content: { width: 'min(100%, 430px)', minHeight: 'calc(100vh - 56px)', margin: '0 auto', padding: '24px 22px 118px', background: '#fffaf4', borderRadius: '0 0 44px 44px', boxShadow: '0 28px 80px rgba(66,44,38,.10), inset 0 -1px 0 rgba(255,255,255,.95)' },
  title: { fontSize: '22px', fontWeight: 600, color: '#251c19', margin: '0 0 6px', letterSpacing: 0 },
  titleSpan: { fontStyle: 'normal', color: '#251c19' },
  sub: { fontSize: '13px', color: '#8c7f70', marginBottom: '24px', lineHeight: 1.55 },
  step: { background: 'rgba(255,255,255,.78)', border: '1px solid rgba(255,255,255,.72)', borderRadius: '28px', padding: '18px', marginBottom: '14px', boxShadow: '0 12px 28px rgba(82,69,57,.055), inset 0 1px 0 rgba(255,255,255,.84)' },
  calendarStep: { background: 'rgba(255,255,255,.78)', border: '1px solid rgba(255,255,255,.72)', borderRadius: '28px', padding: '16px 18px 14px', marginBottom: '14px', boxShadow: '0 12px 28px rgba(82,69,57,.055), inset 0 1px 0 rgba(255,255,255,.84)' },
  stepLabel: { fontSize: '11px', fontWeight: 600, letterSpacing: '.09em', textTransform: 'uppercase', color: '#895b40', marginBottom: '8px' },
  stepTitle: { fontSize: '17px', fontWeight: 600, color: '#251c19', marginBottom: '16px', letterSpacing: 0 },
  calNav: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '10px' },
  calMonth: { fontSize: '15px', fontWeight: 600, color: '#251c19' },
  calNavBtn: { width: '32px', height: '32px', padding: 0, border: '1px solid rgba(216,202,182,.86)', borderRadius: '999px', background: 'rgba(255,255,255,.68)', cursor: 'pointer', fontSize: '13px', color: '#7f7165' },
  calGrid: { display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: '2px' },
  calDayLabel: { textAlign: 'center', fontSize: '9px', fontWeight: 700, letterSpacing: '0.05em', textTransform: 'uppercase', color: 'var(--text-2)', padding: '2px 0', marginBottom: '0' },
  calDay: { height: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '12px', fontSize: '12px', fontWeight: 500, border: '1px solid transparent', transition: 'all 0.15s' },
  calDayAvail: { background: '#f4eee6', borderColor: 'rgba(137,91,64,.16)', color: '#251c19', cursor: 'pointer', fontWeight: 600 },
  calDaySelected: { background: '#895b40', borderColor: '#895b40', color: '#fff', cursor: 'pointer' },
  calDayUnavail: { color: 'rgba(37,28,25,0.2)', cursor: 'default' },
  calDayEmpty: { cursor: 'default' },
  horariosGrid: { display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '8px' },
  horarioBtn: { padding: '10px 8px', border: '1px solid rgba(151,142,134,.16)', borderRadius: '999px', background: '#f4eee6', fontSize: '13px', fontWeight: 500, color: '#524539', cursor: 'pointer', textAlign: 'center', transition: 'all 0.15s' },
  horarioBtnSelected: { background: '#895b40', borderColor: '#895b40', color: '#fff' },
  typeGrid: { display: 'grid', gap: '10px', marginBottom: '14px' },
  typeBtn: { width: '100%', minHeight: '66px', display: 'grid', gridTemplateColumns: '42px 1fr', alignItems: 'center', gap: '12px', padding: '12px', border: '1px solid rgba(255,255,255,.72)', borderRadius: '24px', background: 'rgba(255,255,255,.72)', boxShadow: '0 10px 24px rgba(82,69,57,.045)', color: '#251c19', textAlign: 'left', cursor: 'pointer' },
  typeBtnActive: { background: '#251c19', color: '#fff9f2', borderColor: '#251c19', boxShadow: '0 16px 36px rgba(37,28,25,.14)' },
  typeIcon: { width: '42px', height: '42px', borderRadius: '17px', display: 'grid', placeItems: 'center', background: '#e8d5c7', color: '#7c4f36', fontSize: '18px' },
  typeText: { display: 'block', fontSize: '14px', fontWeight: 600, lineHeight: 1.2 },
  typeSub: { display: 'block', fontSize: '12px', fontWeight: 400, lineHeight: 1.35, opacity: .72, marginTop: '3px' },
  label: { display: 'block', fontSize: '11px', fontWeight: 600, letterSpacing: '0.08em', textTransform: 'uppercase', color: 'var(--text-3)', marginBottom: '6px' },
  input: { width: '100%', padding: '12px 14px', border: '1px solid rgba(151,142,134,.16)', borderRadius: '18px', fontSize: '14px', color: '#251c19', background: '#f4eee6', outline: 'none', marginBottom: '16px', boxSizing: 'border-box' },
  select: { width: '100%', padding: '12px 14px', border: '1px solid rgba(151,142,134,.16)', borderRadius: '18px', fontSize: '14px', color: '#251c19', background: '#f4eee6', outline: 'none', marginBottom: '16px', boxSizing: 'border-box' },
  textarea: { width: '100%', padding: '12px 14px', border: '1px solid rgba(151,142,134,.16)', borderRadius: '18px', fontSize: '14px', color: '#251c19', background: '#f4eee6', outline: 'none', resize: 'vertical', minHeight: '72px', marginBottom: '16px', boxSizing: 'border-box' },
  submitBtn: { width: '100%', padding: '14px', background: '#251c19', color: '#fff9f2', border: 'none', borderRadius: '999px', fontSize: '13px', fontWeight: 600, letterSpacing: '0.04em', textTransform: 'uppercase', cursor: 'pointer' },
  submitBtnDisabled: { opacity: 0.4, cursor: 'not-allowed' },
  selectedInfo: { padding: '12px 16px', background: 'rgba(200,146,42,0.06)', border: '1px solid rgba(200,146,42,0.2)', borderRadius: 'var(--r-btn)', fontSize: '13px', color: 'var(--text)', marginBottom: '16px', lineHeight: 1.6 },
  noSlots: { padding: '24px', textAlign: 'center', color: 'var(--text-2)', fontSize: '13px', lineHeight: 1.6 },
  success: { padding: '28px', textAlign: 'center', background: 'rgba(255,255,255,.78)', border: '1px solid rgba(255,255,255,.72)', borderRadius: '28px', boxShadow: '0 12px 28px rgba(82,69,57,.055)' },
  successIcon: { fontSize: '44px', marginBottom: '16px' },
  successTitle: { fontFamily: "'Inter', sans-serif", fontSize: '24px', fontWeight: 700, color: 'var(--text)', marginBottom: '8px' },
  successText: { fontSize: '14px', color: 'var(--text-2)', lineHeight: 1.7, marginBottom: '28px' },
  backLink: { display: 'inline-block', padding: '12px 28px', background: 'var(--text)', color: '#FAF7F2', borderRadius: 'var(--r-btn)', fontSize: '13px', fontWeight: 600, letterSpacing: '0.06em', textTransform: 'uppercase', cursor: 'pointer', border: 'none' },
};

export default function AlunaAgendarAvaliacao() {
  const { user } = useAuth();
  const { disponibilidade, salvarAgendamento } = useData();
  const { lang } = useLang();
  const navigate = useNavigate();
  const isPt = lang === 'pt';
  const tx = {
    back: isPt ? 'Voltar' : 'Back',
    backPanel: isPt ? 'Voltar ao painel' : 'Back to dashboard',
    titleA: isPt ? 'Agendar' : 'Schedule',
    titleB: isPt ? 'Consulta' : 'Consultation',
    subtitle: isPt ? 'Escolha o tipo de consulta, um dia disponível no calendário e o horário.' : 'Choose the consultation type, an available calendar day and a time.',
    noSlots: isPt ? 'Ainda não há horários disponíveis configurados pela equipe.' : 'There are no available times configured by the team yet.',
    contact: isPt ? 'Entre em contato pelo WhatsApp para agendar diretamente.' : 'Contact us on WhatsApp to schedule directly.',
    step1: isPt ? 'Passo 1' : 'Step 1',
    step2: isPt ? 'Passo 2' : 'Step 2',
    step3: isPt ? 'Passo 3' : 'Step 3',
    step4: isPt ? 'Passo 4' : 'Step 4',
    type: isPt ? 'Tipo de agendamento' : 'Appointment type',
    day: isPt ? 'Escolha o dia' : 'Choose a day',
    time: isPt ? 'Escolha o horário' : 'Choose a time',
    confirm: isPt ? 'Confirmar' : 'Confirm',
    available: isPt ? 'disponível' : 'available',
    noTimes: isPt ? 'Sem horários' : 'No times',
    notes: isPt ? 'Observações (opcional)' : 'Notes (optional)',
    notesPlaceholder: isPt ? 'Conte um pouco sobre seus objetivos ou disponibilidade...' : 'Tell us a little about your goals or availability...',
    confirming: isPt ? 'Confirmando...' : 'Confirming...',
    confirmBooking: isPt ? 'Confirmar agendamento' : 'Confirm appointment',
    done: isPt ? 'Agendado!' : 'Scheduled!',
    teamConfirm: isPt ? 'A equipe vai confirmar em breve pelo WhatsApp.' : 'The team will confirm soon on WhatsApp.',
    conflict: isPt ? 'Esse horário acabou de ser reservado por outra pessoa. Escolha outro horário.' : 'This time was just booked by someone else. Choose another time.',
    error: isPt ? 'Não foi possível agendar. Tente novamente.' : 'Could not schedule. Please try again.',
  };

  const hoje = new Date();
  const [mes, setMes] = useState(hoje.getMonth());
  const [ano, setAno] = useState(hoje.getFullYear());
  const [diaSelecionado, setDiaSelecionado] = useState(null);
  const [horarioSelecionado, setHorarioSelecionado] = useState(null);
  const modalidade = 'online';
  const [tipo, setTipo] = useState('avaliacao');
  const [obs, setObs] = useState('');
  const [done, setDone] = useState(false);
  const [erro, setErro] = useState(null);
  const [enviando, setEnviando] = useState(false);

  function toKey(dia) {
    return `${ano}-${String(mes + 1).padStart(2, '0')}-${String(dia).padStart(2, '0')}`;
  }

  function isPast(dia) {
    const d = new Date(ano, mes, dia); d.setHours(23, 59, 59);
    return d < hoje;
  }

  function getDias() {
    const primeiroDia = new Date(ano, mes, 1).getDay();
    const totalDias = new Date(ano, mes + 1, 0).getDate();
    const dias = [];
    for (let i = 0; i < primeiroDia; i++) dias.push(null);
    for (let d = 1; d <= totalDias; d++) dias.push(d);
    return dias;
  }

  function navMes(dir) {
    let nm = mes + dir, na = ano;
    if (nm < 0) { nm = 11; na--; }
    if (nm > 11) { nm = 0; na++; }
    setMes(nm); setAno(na);
    setDiaSelecionado(null); setHorarioSelecionado(null);
  }

  function handleDia(dia) {
    if (!dia || isPast(dia)) return;
    const key = toKey(dia);
    const slots = disponibilidade[key] || [];
    if (slots.length === 0) return;
    setDiaSelecionado(dia);
    setHorarioSelecionado(null);
  }

  function diaStyle(dia) {
    if (!dia) return { ...s.calDay, ...s.calDayEmpty };
    if (isPast(dia)) return { ...s.calDay, ...s.calDayUnavail };
    const key = toKey(dia);
    const hasSlots = (disponibilidade[key] || []).length > 0;
    if (!hasSlots) return { ...s.calDay, ...s.calDayUnavail };
    if (diaSelecionado === dia) return { ...s.calDay, ...s.calDaySelected };
    return { ...s.calDay, ...s.calDayAvail };
  }

  async function handleSubmit() {
    if (!diaSelecionado || !horarioSelecionado) return;
    setErro(null);
    setEnviando(true);
    const resultado = await salvarAgendamento({
      alunaId: user.id,
      nome: user.name,
      email: user.email,
      data: toKey(diaSelecionado),
      horario: horarioSelecionado,
      modalidade,
      tipo,
      obs,
    });
    setEnviando(false);
    if (!resultado.success) {
      if (resultado.conflito) {
        setErro(tx.conflict);
        setHorarioSelecionado(null);
      } else {
        setErro(tx.error);
      }
      return;
    }
    setDone(true);
  }

  const slotsDisponiveis = diaSelecionado ? (disponibilidade[toKey(diaSelecionado)] || []) : [];
  const tipoCards = [
    { key: 'avaliacao', icon: '📅', label: TIPOS_CONSULTA.avaliacao[lang], sub: isPt ? 'Avaliação e medidas' : 'Assessment and measurements' },
    { key: 'revisao_treino', icon: '🏃', label: TIPOS_CONSULTA.revisao_treino[lang], sub: isPt ? 'Ajustes do treino' : 'Workout adjustments' },
    { key: 'revisao_nutricao', icon: '🍽️', label: TIPOS_CONSULTA.revisao_nutricao[lang], sub: isPt ? 'Ajustes da nutrição' : 'Nutrition adjustments' },
  ];

  const dataFormatada = diaSelecionado
    ? new Date(ano, mes, diaSelecionado).toLocaleDateString(isPt ? 'pt-BR' : 'en-US', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })
    : null;

  const temDisponibilidade = Object.keys(disponibilidade).some(k => {
    const d = new Date(k); d.setHours(23,59,59);
    return d >= hoje && (disponibilidade[k] || []).length > 0;
  });

  if (done) return (
    <div style={s.page}>
      <nav style={s.nav}><img src="/logo.svg" alt="Team Carol Macedo" style={{ height:'30px', width:'auto', objectFit:'contain' }} /></nav>
      <div style={s.content}>
        <div style={s.success}>
          <div style={s.successIcon}>✓</div>
          <div style={s.successTitle}>{tx.done}</div>
          <div style={s.successText}>
            {isPt ? 'Sua' : 'Your'} <strong>{TIPOS_CONSULTA[tipo][lang].toLowerCase()}</strong> {isPt ? 'foi solicitada para' : 'was requested for'} <strong>{dataFormatada}</strong> {isPt ? 'às' : 'at'} <strong>{horarioSelecionado}</strong>.<br />
            {tx.teamConfirm}
          </div>
          <button style={s.backLink} onClick={() => navigate('/aluna')}>{tx.backPanel}</button>
        </div>
      </div>
      <AlunaTabBar current="agendar" />
    </div>
  );

  return (
    <div style={s.page}>
      <nav style={s.nav}>
        <img src="/logo.svg" alt="Team Carol Macedo" style={{ height:'30px', width:'auto', objectFit:'contain' }} />
        <button style={s.backBtn} onClick={() => navigate('/aluna')}>{tx.back}</button>
      </nav>
      <div style={s.content}>
        <h1 style={s.title}>{tx.titleA} <span style={s.titleSpan}>{tx.titleB}</span></h1>
        <p style={s.sub}>{tx.subtitle}</p>

        {!temDisponibilidade ? (
          <div style={s.step}>
            <div style={s.noSlots}>
              <div style={{ fontSize:30, marginBottom:10 }}>📅</div>
              <strong style={{ display:'block', color:'#251c19', fontSize:15, marginBottom:5 }}>{tx.noSlots}</strong>
              <span>{tx.contact}</span>
              <a href={`https://wa.me/19549974866?text=${encodeURIComponent(isPt ? 'Olá, quero agendar uma consulta pelo app Team Carol Macedo.' : 'Hi, I would like to schedule an appointment through the Team Carol Macedo app.')}`} target="_blank" rel="noreferrer" style={{ display:'block', marginTop:16, padding:'12px 18px', borderRadius:999, background:'#251c19', color:'#fff9f2', textDecoration:'none', fontWeight:650 }}>
                {isPt ? 'Agendar pelo WhatsApp →' : 'Schedule on WhatsApp →'}
              </a>
            </div>
          </div>
        ) : (
          <>
            <div style={s.step}>
              <div style={s.stepLabel}>{tx.step1}</div>
              <div style={s.stepTitle}>{tx.type}</div>
              <div style={s.typeGrid}>
                {tipoCards.map(item => {
                  const ativo = tipo === item.key;
                  return (
                    <button
                      key={item.key}
                      type="button"
                      onClick={() => setTipo(item.key)}
                      style={{ ...s.typeBtn, ...(ativo ? s.typeBtnActive : {}) }}
                    >
                      <span style={{ ...s.typeIcon, ...(ativo ? { background: 'rgba(255,255,255,.14)', color: '#fff9f2' } : {}) }}>{item.icon}</span>
                      <span>
                        <span style={s.typeText}>{item.label}</span>
                        <span style={s.typeSub}>{item.sub}</span>
                      </span>
                    </button>
                  );
                })}
              </div>
            </div>

            <div style={s.calendarStep}>
              <div style={s.stepLabel}>{tx.step2}</div>
              <div style={{ ...s.stepTitle, marginBottom: '10px' }}>{tx.day}</div>
              <div style={s.calNav}>
                <button style={s.calNavBtn} onClick={() => navMes(-1)}>←</button>
                <div style={s.calMonth}>{MESES[lang][mes]} {ano}</div>
                <button style={s.calNavBtn} onClick={() => navMes(1)}>→</button>
              </div>
              <div style={s.calGrid}>
                {DIAS_SEMANA[lang].map(d => <div key={d} style={s.calDayLabel}>{d}</div>)}
                {getDias().map((dia, idx) => (
                  <div key={idx} style={diaStyle(dia)} onClick={() => dia && handleDia(dia)}>{dia}</div>
                ))}
              </div>
              <div style={{ marginTop: '8px', fontSize: '11px', color: '#8C7F70', display: 'flex', gap: '12px' }}>
                <span>● {tx.available}</span>
                <span style={{ color: 'rgba(37,28,25,0.3)' }}>{tx.noTimes}</span>
              </div>
            </div>

            {diaSelecionado && (
              <div style={s.step}>
                <div style={s.stepLabel}>{tx.step3}</div>
                <div style={s.stepTitle}>{tx.time}</div>
                <div style={{ fontSize: '13px', color: '#8C7F70', marginBottom: '16px' }}>{dataFormatada}</div>
                <div style={s.horariosGrid}>
                  {slotsDisponiveis.map(h => (
                    <button
                      key={h}
                      style={{ ...s.horarioBtn, ...(horarioSelecionado === h ? s.horarioBtnSelected : {}), display:'flex', alignItems:'center', justifyContent:'center', gap:'5px' }}
                      onClick={() => setHorarioSelecionado(h)}
                    ><span style={{ width:'7px', height:'7px', borderRadius:'50%', background: horarioSelecionado === h ? '#fff' : '#2E7D32', flexShrink:0 }} />{h}</button>
                  ))}
                </div>
              </div>
            )}

            {horarioSelecionado && (
              <div style={s.step}>
                <div style={s.stepLabel}>{tx.step4}</div>
                <div style={s.stepTitle}>{tx.confirm}</div>
                {dataFormatada && (
                  <div style={s.selectedInfo}>
                    <strong>{TIPOS_CONSULTA[tipo][lang]}</strong><br />
                    📅 <strong>{dataFormatada}</strong> {isPt ? 'às' : 'at'} <strong>{horarioSelecionado}</strong>
                  </div>
                )}
                <label style={s.label}>{tx.notes}</label>
                <textarea style={s.textarea} value={obs} onChange={e => setObs(e.target.value)} placeholder={tx.notesPlaceholder} />
                {erro && (
                  <div style={{ padding:'11px 13px', background:'rgba(229,57,53,0.07)', border:'1px solid rgba(229,57,53,0.2)', color:'#C62828', borderRadius:'var(--r-btn)', fontSize:'13px', marginBottom:'16px' }}>
                    {erro}
                  </div>
                )}
                <button
                  style={{ ...s.submitBtn, background: diaSelecionado && horarioSelecionado ? '#2E7D32' : 'rgba(37,28,25,0.15)', color: diaSelecionado && horarioSelecionado ? '#fff' : 'var(--text-2)', ...(!diaSelecionado || !horarioSelecionado || enviando ? s.submitBtnDisabled : {}) }}
                  onClick={handleSubmit}
                  disabled={!diaSelecionado || !horarioSelecionado || enviando}
                >
                  {enviando ? tx.confirming : tx.confirmBooking}
                </button>
              </div>
            )}
          </>
        )}
      </div>
      <AlunaTabBar current="agendar" />
    </div>
  );
}
